module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAyCAMAAACqJUG4AAAAS1BMVEXt7vDo6uzy8/Tf4uTY3N+AgI/29vfW2t3P1NfR1djr7e/6+vq+yNna3uDv8PHI0d/h5Ob4+PjW3ObCzNzk5+7d4urP1uLl5+nT19oYgrzJAAAAP0lEQVR4XjXKRRbAQAzDUA2WGe9/0mrT/I3zbAr/9QQSmZdWHTI3ykwkrTwKLmEmqmrTIPlF25OLnZuFg5HyAU5YAePBJvZUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/images/choose-subjects.png
// module id = 517
// module chunks = 0